import { render } from "./StockAdjustment.vue?vue&type=template&id=0351e1aa&scoped=true"
import script from "./StockAdjustment.vue?vue&type=script&lang=js"
export * from "./StockAdjustment.vue?vue&type=script&lang=js"

import "./StockAdjustment.vue?vue&type=style&index=0&id=0351e1aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0351e1aa"]])

export default __exports__